import { render, staticRenderFns } from "./TopReasons.vue?vue&type=template&id=a440abfe&"
var script = {}
import style0 from "./TopReasons.vue?vue&type=style&index=0&id=a440abfe&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports